import {
  FormControlLabel,
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Radio as MuiRadio,
  type RadioProps as MuiRadioProps,
} from '@mui/material'
import { type DataTestIdAttribute, type FormControlInputProps, type HTMLAttributesWithoutStyling } from '../../types'

export type RadioProps = HTMLAttributesWithoutStyling<HTMLButtonElement> &
  Pick<MuiRadioProps, 'onChange' | 'disabled' | 'edge' | 'name' | 'value' | 'checked' | 'slotProps'> &
  FormControlInputProps &
  DataTestIdAttribute

export const Radio = ({ label, labelPlacement, ...props }: RadioProps) =>
  label ? (
    <FormControlLabel
      sx={{
        mr: 0,
        width: 'fit-content',
      }}
      control={<MuiRadio {...props} />}
      label={label}
      labelPlacement={labelPlacement}
    />
  ) : (
    <MuiRadio {...props} />
  )
